document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.accordion-header')

  faqItems.forEach((item) => {
    item.addEventListener('click', function () {
      faqItems.forEach((i) => {
        if (i === item) {
          i.parentElement.classList.toggle('active')
        } else {
          i.parentElement.classList.remove('active')
        }
      })
    })
  })
})
